import { useFetchQuery } from "common/queries/hooks";
import { ShippingRateSummary } from "common/types/shipping";

import { keys, urls } from "./constants";

export const useShippingRatesSummaryQuery = () => {
  return useFetchQuery<ShippingRateSummary>(keys.rateSummary(), {
    fetch: { url: urls.ratesSummary() },
  });
};
